import React from 'react';
import { Grid, GridProps, withStyles } from '@material-ui/core';
import cn from 'classnames';

interface FsGridItemProps extends GridProps {
  isVerticalPadding?: boolean;
  isFlex?: boolean;
}

export default withStyles(() => ({
  root: {
    display: 'block',
    '&.isNoVerticalPadding': {
      paddingTop: 0,
      paddingBottom: 0,
    },
    '&.isFlex': {
      display: 'flex',
    },
  },
}))(
  ({
    isVerticalPadding = true,
    isFlex = false,
    ...otherProps
  }: FsGridItemProps) => (
    <Grid
      item
      {...otherProps}
      className={cn({ isNoVerticalPadding: !isVerticalPadding, isFlex })}
    />
  )
);
